import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Api from "../../../../component/Api";

const useMenu = (viewComponents = {}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [menuData, setMenuData] = useState([]);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [activeNestMenu, setActiveNestMenu] = useState(null);
    const [menuLoading, setMenuLoading] = useState(true);

    const menuFetchedRef = useRef(false);

    const hashParts = location.hash.replace("#", "").split("?");
    const hashPath = hashParts[0];
    const pathSegments = hashPath.split("/").filter(Boolean);

    const currentHash = pathSegments[0] || "";
    const routeParams = pathSegments.slice(1);
    const studentId = routeParams[0] || null;
    const hashParams = new URLSearchParams(hashParts[1] || "");

    useEffect(() => {
        if (!location.hash && Object.keys(viewComponents).length > 0) {
            navigate(`${location.pathname}#home`, { replace: true });
        }
    }, [location.hash, location.pathname, navigate, viewComponents]);

    useEffect(() => {
        if (menuFetchedRef.current) return;

        const fetchMenuData = async () => {
            const { http } = Api();
            try {
                setMenuLoading(true);
                const response = await http.get("getusermenus");
                if (response.data?.menus) {
                    setMenuData(response.data.menus);
                    menuFetchedRef.current = true;
                }
            } catch (error) {
                console.error("Error fetching menu data:", error);
                navigate("/");
            } finally {
                setMenuLoading(false);
            }
        };

        fetchMenuData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (menuData.length === 0) return;

        const activeMenuItem = menuData.find(
            (menuItem) =>
                menuItem.url === currentHash ||
                menuItem.url === location.pathname.substring(1)
        );

        if (activeMenuItem) {
            if (activeMenuItem.parent_id) {
                const parentMenuItem = menuData.find(
                    (m) => m.id === activeMenuItem.parent_id
                );
                if (parentMenuItem?.parent_id) {
                    setActiveSubMenu(parentMenuItem.parent_id);
                    setActiveNestMenu(activeMenuItem.parent_id);
                } else {
                    setActiveSubMenu(activeMenuItem.parent_id);
                    setActiveNestMenu(activeMenuItem.id);
                }
            } else if (activeMenuItem.id === 4 || activeMenuItem.id === 2) {
                setActiveSubMenu(activeMenuItem.id);
            } else {
                setActiveSubMenu(null);
                setActiveNestMenu(null);
            }
        }
    }, [location.pathname, currentHash, menuData]);

    const handleMenuClick = (menuId, url) => {
        if (url === "/null") {
            setActiveSubMenu((prev) => (prev === menuId ? null : menuId));
        } else {
            navigate(url);
        }
    };

    const handleNestMenuClick = (menuId, url) => {
        if (url === "/null") {
            setActiveNestMenu((prev) => (prev === menuId ? null : menuId));
        } else {
            navigate(url);
        }
    };

    const isMenuActive = (menuUrl) => {
        if (menuUrl.includes("#")) {
            const menuHash = menuUrl.split("#")[1];
            return currentHash === menuHash;
        }
        return location.pathname === menuUrl;
    };

    return {
        menuData,
        menuLoading,
        activeSubMenu,
        activeNestMenu,
        currentHash,
        studentId,
        hashParams,
        handleMenuClick,
        handleNestMenuClick,
        isMenuActive,
    };
};

export default useMenu;